import { render, staticRenderFns } from "./BinCollectionScheduleItem.vue?vue&type=template&id=4ee7c59c"
import script from "./BinCollectionScheduleItem.vue?vue&type=script&lang=js"
export * from "./BinCollectionScheduleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports